// Whether a `bv_reduce_bucket` result should become a charge line.
//
// Interval treatments (max demand, CPD averages) are only meaningful when they
// read some interval rows: `rows_considered = 0` means "not calculated", and the
// line is left out rather than billed at zero.
//
// A site-fixed-value treatment (SITE_FIXED_VALUE, params `{source: ...}` — e.g.
// AusNet's Network Specified Capacity reading `site.bv_extn.specified_capacity`)
// reads NO interval rows by design, so `rows_considered` is always 0 and the
// gate above dropped every such charge (job 98). For those the value itself is
// the signal: present (> 0) is a charge, absent (0) is still "not calculated".

export type ReducedBucketResult = { quantity?: unknown; rows_considered?: unknown } | null | undefined;

export const isSiteFixedValue = (params: unknown): boolean =>
  !!params && typeof params === 'object' && typeof (params as Record<string, unknown>).source === 'string';

export function keepReducedBucket(r: ReducedBucketResult, params: unknown): boolean {
  if (!r) return false;
  if (isSiteFixedValue(params)) return Number(r.quantity) > 0;
  return Number(r.rows_considered) > 0;
}
